import Backbone from 'backbone-collection';

import sync from './BackboneSync';

export default class Collection<TModel> extends Backbone.Collection<TModel> {
  add(models: TModel | Array<TModel>, options: Object = {}) {
    // Make add() use `merge` by default
    return super.add(models, Object.assign({ merge: true }, options));
  }

  fetch(options: { success?: any; error?: any } = {}): any {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (_model: any, response: any) => {
        reject(response);
      };
      super.fetch(options);
    });
  }

  // eslint-disable-next-line
  sync(...args: any[]) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'IArguments' is not assignable to... Remove this comment to see the full error message
    return sync.apply(this, arguments);
  }

  jasmineToString(): string {
    return '[' + this.length + ' ' + this.model && (this.model as any).name + 's]';
  }

  static fetch<TModel>(options = {}): Promise<Collection<TModel>> {
    return new this().fetch(options);
  }

  static fromJSON<TModel>(models: [] = []): Collection<TModel> {
    return new this<TModel>(models, { parse: true });
  }
}
